import React from 'react';
import { WavyBackground } from './WavyBackground';
import { TypewriterEffect } from './TypewriterEffect';
import GitHubIcon from '../assets/svgs/githubIcon';
import LinekdInIcon from '../assets/svgs/linkedInIcon';
import InstagramIcon from '../assets/svgs/instagramIcon';
import PhoneIcon from '../assets/svgs/phoneIcon';
import EmailIcon from '../assets/svgs/emailIcon';
import ContactForm from './ContactForm';
function ContactMeScreen() {
  const headline = [
    {
      text: 'Get',
    },
    {
      text: 'in ',
    },
    {
      text: 'touch ',
    },
    {
      text: 'with ',
    },
    {
      text: 'Me',
      className: 'text-blue-500 dark:text-blue-500',
    },
  ];

  return (
    <div className='w-screen h-screen'>
      <WavyBackground waveWidth={25} speed='slow'>
        <div className='w-screen h-screen text-white py-10 px-5'>
          <TypewriterEffect
            className='z-50 text-center text-lg '
            words={headline}
          />
          <div className='flex flex-col md:flex-col justify-evenly md:items-center items-center w-full'>
            <div className='flex flex-row gap-5 md:gap-14 justify-evenly md:justify-center align-middle my-8 sm:w-2/5'>
              <div className='flex flex-col md:flex-row gap-5 sm:gap-14 justify-evenly sm:justify-center align-middle'>
                <a href='tel:+421948325351' className='cursor-pointer'>
                  <PhoneIcon width='40' height='40' />
                </a>
                <a
                  href='https://github.com/FilipBrady'
                  className='cursor-pointer'
                >
                  <GitHubIcon width='40' height='40' fill='#FFFFFF' />
                </a>
              </div>
              <div className='flex flex-col md:flex-row gap-5 sm:gap-14 justify-evenly sm:justify-center align-middle'>
                <a
                  href='https://www.linkedin.com/in/filip-br%C3%A1dy-332560237/'
                  className='cursor-pointer'
                >
                  <LinekdInIcon width='40' height='40' />
                </a>
                <a
                  href='https://instagram.com/f._.brady'
                  className='cursor-pointer'
                >
                  <InstagramIcon width='40' height='40' />
                </a>
              </div>
            </div>
            <div className='sm:w-full lg:w-3/5 w-full bg-[#35334d4d] px-2 py-3 rounded-lg'>
              <h2 className='flex flex-row justify-center align-start gap-2 text-xl py-2 pt-4'>
                Or send me a Direct
                <span>
                  <EmailIcon width='30' height='30' />
                </span>
              </h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </WavyBackground>
    </div>
  );
}

export default ContactMeScreen;
